export default __webpack_public_path__ + "static/media/aaran-tech.bb7ecb88.svg";